// extracted by mini-css-extract-plugin
export default {"root":"awRNsZINNh","customHtml":"xWeCssws4v"};